import { DemoRequestSection } from "@/pages/Resources";

export default function Demo() {
  return (
    <div data-testid="demo-page">
      <DemoRequestSection />
    </div>
  );
}
